import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useSwiper } from 'hooks'
import {
  breakpoints,
  CarouselContainer,
  CarouselNextButton,
  CarouselPrevButton
} from 'ui/acro'

import RecommendedItem from './RecommendedItem'
import RecommendedItemExplore from './RecommendedItemExplore'

const RecommendedCarousel = ({ plans }) => {
  const { getSwiperProps, goPrev, goNext, isBeginning, isEnd } = useSwiper()

  return (
    <CarouselContainer>
      <Swiper
        {...getSwiperProps({
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          slidesPerGroup: 2,
          slidesPerView: 'auto',
          spaceBetween: 11,
          breakpoints: {
            [breakpoints[2]]: {
              slidesOffsetBefore: 0
            },
            // We set this breakpoint because current design breaks down below it.
            1420: {
              spaceBetween: 23,
              slidesOffsetBefore: 0,
              slidesPerGroup: 4
            }
          }
        })}
      >
        {plans.map((plan, index) => (
          <SwiperSlide
            tag={RecommendedItem}
            key={index}
            index={index}
            plan={plan}
            titleLines={1}
            coachLines={2}
          />
        ))}
        <SwiperSlide tag={RecommendedItemExplore} />
      </Swiper>

      <CarouselPrevButton
        handleClick={goPrev}
        disabled={isBeginning}
        display={['none', null, 'inherit']}
        id='recommended-carousel-prev'
        aria-label='Previous'
      />
      <CarouselNextButton
        handleClick={goNext}
        disabled={isEnd}
        display={['none', null, 'inherit']}
        id='recommended-carousel-next'
        aria-label='Next'
      />
    </CarouselContainer>
  )
}

RecommendedCarousel.propTypes = {
  plans: PropTypes.array
}

export default RecommendedCarousel
